let MenuAudit42NoQLTS = [
  {
    typeAudit: 4,
    text: '4.2.1. Danh sách chứng từ liên quan tới TSCĐ không hiển thị trên Sổ TSCĐ',
    isParent: false,
    part: 1,
    level: 3,
    toggleAuditValue: 421,
    errorAuditValue: 421,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.2. Danh sách TSCĐ mua mới đã khai báo nhưng không hiển thị trên Sổ cái và Sổ TSCĐ',
    isParent: false,
    part: 2,
    level: 3,
    toggleAuditValue: 422,
    errorAuditValue: 422,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.3. Danh sách chứng từ ghi tăng khác với thông tin tài sản đang khai báo',
    isParent: false,
    part: 3,
    level: 3,
    toggleAuditValue: 423,
    errorAuditValue: 423,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.4 Danh sách chứng từ đánh giá lại TSCĐ hạch toán khác với thông tin điều chỉnh TSCĐ',
    isParent: false,
    part: 4,
    level: 3,
    toggleAuditValue: 424,
    errorAuditValue: 424,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.5. Các kỳ chưa trích khấu hao tài sản cố định',
    isParent: false,
    part: 5,
    level: 3,
    toggleAuditValue: 425,
    errorAuditValue: 425,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.6. Kiểm tra tính hao mòn tài sản cố định trong kỳ',
    isParent: false,
    part: 6,
    level: 3,
    toggleAuditValue: 426,
    errorAuditValue: 426,
    parentAuditValue: [4, 42],
  },
];

let MenuAudit42QLTS = [
  {
    typeAudit: 4,
    text: '4.2.1. Danh sách chứng từ liên quan tới TSCĐ không hiển thị trên Sổ TSCĐ',
    isParent: false,
    part: 1,
    level: 3,
    toggleAuditValue: 421,
    errorAuditValue: 421,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.2. Danh sách tài sản đã ghi tăng trên QLTS.VN chưa hạch toán trên Mimosa Online',
    isParent: false,
    part: 2,
    level: 3,
    toggleAuditValue: 422,
    errorAuditValue: 422,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.3. Danh sách chứng từ ghi tăng TSCĐ trên Mimosa Online có số tiền khác với chứng từ ghi tăng trên QLTS.VN',
    isParent: false,
    part: 3,
    level: 3,
    toggleAuditValue: 423,
    errorAuditValue: 423,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.4. Danh sách tài sản đã đánh giá lại trên QLTS.VN chưa hạch toán trên Mimosa Online',
    isParent: false,
    part: 4,
    level: 3,
    toggleAuditValue: 424,
    errorAuditValue: 424,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.5. Danh sách chứng từ đánh giá lại TSCĐ trên Mimosa Online có số tiền khác với chứng từ đánh giá lại trên QLTS.VN',
    isParent: false,
    part: 5,
    level: 3,
    toggleAuditValue: 425,
    errorAuditValue: 425,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.6. Danh sách chứng từ trích khấu hao TSCĐ trên QLTS.VN chưa được hạch toán trên MISA Mimosa Online',
    isParent: false,
    part: 6,
    level: 3,
    toggleAuditValue: 426,
    errorAuditValue: 426,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.7. Danh sách chứng từ trích khấu hao TSCĐ trên Mimosa Online có số tiền khác với chứng từ trích khấu hao trên QLTS.VN',
    isParent: false,
    part: 7,
    level: 3,
    toggleAuditValue: 427,
    errorAuditValue: 427,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.8. Danh sách chứng từ tính hao mòn TSCĐ trên QLTS.VN chưa hạch toán trên MISA Mimosa Online',
    isParent: false,
    part: 8,
    level: 3,
    toggleAuditValue: 428,
    errorAuditValue: 428,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.9. Danh sách chứng từ tính hao mòn TSCĐ trên Mimosa Online có số tiền khác với chứng từ tính hao mòn trên QLTS.VN',
    isParent: false,
    part: 9,
    level: 3,
    toggleAuditValue: 429,
    errorAuditValue: 429,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.10. Danh sách chứng từ ghi giảm TSCĐ trên QLTS.VN chưa hạch toán trên MISA Mimosa Online ',
    isParent: false,
    part: 10,
    level: 3,
    toggleAuditValue: 4210,
    errorAuditValue: 4210,
    parentAuditValue: [4, 42],
  },
  {
    typeAudit: 4,
    text: '4.2.11. Danh sách chứng từ ghi giảm TSCĐ trên Mimosa Online có số tiền khác với chứng từ ghi giảm trên QLTS.VN',
    isParent: false,
    part: 11,
    level: 3,
    toggleAuditValue: 4211,
    errorAuditValue: 4211,
    parentAuditValue: [4, 42],
  },
];

let MenuAudit4NoQLTS = [
  {
    typeAudit: 4,
    text: '4.1. Lệch số dư TK nguyên giá, hao mòn lũy kế với số tiền trên Danh sách TSCĐ',
    isParent: false,
    part: 1,
    level: 2,
    toggleAuditValue: 41,
    errorAuditValue: 41,
    parentAuditValue: [4],
  },
  {
    typeAudit: 4,
    text: '4.2. Danh sách các chứng từ hạch toán tài sản trong kỳ có hạch toán chưa phù hợp',
    isParent: true,
    part: 2,
    level: 2,
    toggleAuditValue: 42,
    errorAuditValue: 42,
    parentAuditValue: [4],
    childrens: MenuAudit42NoQLTS,
  },
];

let MenuAudit4QLTS = [
  {
    typeAudit: 4,
    text: '4.1 Chênh lệch số dư đầu năm giữa Mimosa Online và QLTS.VN',
    isParent: false,
    part: 1,
    level: 2,
    toggleAuditValue: 41,
    errorAuditValue: 41,
    parentAuditValue: [4],
  },
  {
    typeAudit: 4,
    text: '4.2. Danh sách các chứng từ hạch toán tài sản trong kỳ có hạch toán chưa phù hợp (Kết nối QLTS.VN)',
    isParent: true,
    part: 2,
    level: 2,
    toggleAuditValue: 42,
    errorAuditValue: 42,
    parentAuditValue: [4],
    childrens: MenuAudit42QLTS,
  },
];

let MenuAudits = [
  {
    typeAudit: 1,
    key: 'unrecord-document',
    text: '1. Chứng từ chưa ghi sổ',
    level: 1,
    toggleAuditValue: 1,
    errorAuditValue: 1,
    parentAuditValue: [],
    isVisible: true,
  },
  {
    typeAudit: 2,
    key: 'cash-deposit',
    text: '2. Tiền mặt, tiền gửi',
    level: 1,
    isParent: true,
    toggleAuditValue: 2,
    errorAuditValue: 2,
    parentAuditValue: -1,
    isVisible: true,
    childrens: [
      {
        typeAudit: 2,
        text: '2.1 Tiền mặt',
        isParent: false,
        part: 1,
        level: 2,
        toggleAuditValue: 21,
        errorAuditValue: 21,
        parentAuditValue: 2,
      },
      {
        typeAudit: 2,
        text: '2.2 Tiền gửi ngân hàng',
        isParent: false,
        part: 2,
        level: 2,
        toggleAuditValue: 22,
        errorAuditValue: 22,
        parentAuditValue: 2,
      },
    ],
  },
  {
    typeAudit: 3,
    key: '',
    isParent: true,
    level: 1,
    toggleAuditValue: 3,
    errorAuditValue: 3,
    parentAuditValue: -1,
    childrens: [
      {
        typeAudit: 3,
        text: '3.1. Danh sách VTHH tồn có số lượng bằng 0, giá trị khác 0',
        isParent: false,
        part: 1,
        level: 2,
        toggleAuditValue: 31,
        errorAuditValue: 31,
        parentAuditValue: 2,
      },
      {
        typeAudit: 3,
        text: '3.2. Danh sách VTHH tồn có số lượng âm hoặc giá trị âm',
        isParent: false,
        part: 2,
        level: 2,
        toggleAuditValue: 32,
        errorAuditValue: 32,
        parentAuditValue: 2,
      },
    ],
    text: '3. Kho',
    level: 1,
    isVisible: true,
  },
  {
    typeAudit: 4,
    key: '',
    text: '4. Tài sản cố định',
    isParent: true,
    level: 1,
    toggleAuditValue: 4,
    errorAuditValue: 4,
    parentAuditValue: -1,
    childrens: MenuAudit4NoQLTS,
    isVisible: true,
  },
  {
    typeAudit: 5,
    key: '',
    text: '5. Chứng từ chưa thanh toán tạm ứng',
    level: 1,
    isParent: true,
    toggleAuditValue: 5,
    errorAuditValue: 5,
    parentAuditValue: -1,
    childrens: [
      {
        typeAudit: 5,
        text: '5.1. Danh sách Bảng kê chứng từ thanh toán chưa thanh toán',
        isParent: false,
        part: 1,
        level: 2,
        toggleAuditValue: 51,
        errorAuditValue: 51,
        parentAuditValue: 5,
      },
      {
        typeAudit: 5,
        text: '5.2. Danh sách chứng từ chi tạm ứng chưa lập Bảng kê chứng từ thanh toán',
        isParent: false,
        part: 2,
        level: 2,
        toggleAuditValue: 52,
        errorAuditValue: 52,
        parentAuditValue: 5,
      },
    ],
    isVisible: true,
  },
  {
    typeAudit: 6,
    key: '',
    text: '6. Hạch toán tài chính và hạch toán ngoại bảng',
    level: 1,
    isParent: true,
    toggleAuditValue: 6,
    errorAuditValue: 6,
    parentAuditValue: -1,
    childrens: [
      {
        typeAudit: 6,
        text: '6.1. Danh sách chứng từ có chênh lệch giữa hạch toán tài chính và hạch toán ngoại bảng',
        isParent: false,
        part: 1,
        level: 2,
        toggleAuditValue: 61,
        errorAuditValue: 61,
        parentAuditValue: 6,
      },
      {
        typeAudit: 6,
        text: '6.2. Danh sách chứng từ chưa có hạch toán ngoại bảng',
        isParent: false,
        part: 2,
        level: 2,
        toggleAuditValue: 62,
        errorAuditValue: 62,
        parentAuditValue: 6,
      },
    ],
    isVisible: true,
  },
  {
    typeAudit: 7,
    key: '',
    text: '7. Sổ rút và chi theo mục lục ngân sách',
    isParent: true,
    level: 1,
    toggleAuditValue: 7,
    errorAuditValue: 7,
    parentAuditValue: -1,
    childrens: [
      {
        typeAudit: 7,
        text: '7.1. Chênh lệch số rút tạm ứng và thanh toán tạm ứng theo MLNS',
        isParent: false,
        part: 1,
        level: 2,
        toggleAuditValue: 71,
        errorAuditValue: 71,
        parentAuditValue: 7,
      },
      {
        typeAudit: 7,
        text: '7.2. Chênh lệch số rút thực chi và số chi thực chi theo MLNS',
        isParent: false,
        part: 2,
        level: 2,
        toggleAuditValue: 72,
        errorAuditValue: 72,
        parentAuditValue: 7,
      },
    ],
    isVisible: true,
  },
  {
    typeAudit: 8,
    key: '',
    text: '8. Tài khoản lương và các khoản trích theo lương',
    isParent: false,
    part: 1,
    level: 1,
    toggleAuditValue: 8,
    errorAuditValue: 8,
    parentAuditValue: [],
    isVisible: true,
    titleText: '8. Kiểm tra số dư tài khoản lương và các khoản trích theo lương',
  },
  {
    typeAudit: 9,
    key: '',
    text: '9. Nghiệp vụ bất thường',
    isParent: true,
    level: 1,
    toggleAuditValue: 9,
    errorAuditValue: 9,
    parentAuditValue: -1,
    childrens: [
      {
        typeAudit: 9,
        text: '9.1. Các bút toán hạch toán TK thường xuyên nhưng chọn nguồn có tính chất không thường xuyên hoặc ngược lại',
        isParent: false,
        part: 1,
        level: 2,
        toggleAuditValue: 91,
        errorAuditValue: 91,
        parentAuditValue: 9,
      },
      {
        typeAudit: 9,
        text: '9.2. Danh sách nghiệp vụ nộp trả, nộp khôi phục có thông tin hạch toán chưa phù hợp',
        isParent: false,
        part: 2,
        level: 2,
        toggleAuditValue: 92,
        errorAuditValue: 92,
        parentAuditValue: 9,
      },
      {
        typeAudit: 9,
        text: '9.3. Danh sách nghiệp vụ giảm chi, xuất toán có thông tin hạch toán chưa phù hợp',
        isParent: false,
        part: 3,
        level: 2,
        toggleAuditValue: 93,
        errorAuditValue: 93,
        parentAuditValue: 9,
      },
      {
        typeAudit: 9,
        text: '9.4. Danh sách nghiệp vụ lệnh chi tiền có thông tin hạch toán chưa phù hợp',
        isParent: false,
        part: 4,
        level: 2,
        toggleAuditValue: 94,
        errorAuditValue: 94,
        parentAuditValue: 9,
      },
    ],
    isVisible: true,
  },
  {
    typeAudit: 10,
    key: '',
    text: '10. Bảng cân đối phát sinh',
    isParent: true,
    level: 1,
    toggleAuditValue: 10,
    errorAuditValue: 10,
    parentAuditValue: -1,
    childrens: [
      {
        typeAudit: 10,
        text: '10.1. Kiểm tra tổng tài sản và tổng nguồn vốn đầu năm',
        isParent: false,
        part: 1,
        level: 2,
        toggleAuditValue: 101,
        errorAuditValue: 101,
        parentAuditValue: 10,
      },
      {
        typeAudit: 10,
        text: '10.2. Kiểm tra tính chất của các tài khoản so với chế độ hiện hành',
        isParent: false,
        part: 2,
        level: 2,
        toggleAuditValue: 102,
        errorAuditValue: 102,
        parentAuditValue: 10,
      },
      {
        typeAudit: 10,
        text: '10.3. Kiểm tra số dư tài khoản doanh thu, chi phí',
        isParent: false,
        part: 3,
        level: 2,
        toggleAuditValue: 103,
        errorAuditValue: 103,
        parentAuditValue: 10,
      },
    ],
    isVisible: true,
  },
  {
    typeAudit: 11,
    key: '',
    text: '11. Báo cáo tài chính',
    isParent: true,
    part: 1,
    level: 1,
    toggleAuditValue: 11,
    errorAuditValue: 11,
    parentAuditValue: -1,
    isVisible: true,
    report_id: '',
    childrens: [
      {
        typeAudit: 11,
        text: '11.1. Báo cáo B01/BCTC',
        isParent: false,
        part: 1,
        level: 2,
        toggleAuditValue: 111,
        errorAuditValue: 111,
        parentAuditValue: 11,
        report_id: ['BCTC-01-Audit', 'BCTC-01'],
      },
      {
        typeAudit: 11,
        text: '11.2. Báo cáo B02/BCTC',
        isParent: false,
        part: 2,
        level: 2,
        toggleAuditValue: 112,
        errorAuditValue: 112,
        parentAuditValue: 11,
        report_id: ['BCTC-02-Audit', 'BCTC-02'],
      },
      {
        typeAudit: 11,
        text: '11.3. Báo cáo B03a/BCTC',
        isParent: false,
        part: 3,
        level: 2,
        toggleAuditValue: 113,
        errorAuditValue: 113,
        parentAuditValue: 11,
        report_id: ['BCTC-03a-Audit', 'BCTC-03a'],
      },
      {
        typeAudit: 11,
        text: '11.4. Báo cáo B03b/BCTC',
        isParent: false,
        part: 4,
        level: 2,
        toggleAuditValue: 114,
        errorAuditValue: 114,
        parentAuditValue: 11,
        report_id: ['BCTC-03b-Audit', 'BCTC-03b'],
      },
      {
        typeAudit: 11,
        text: '11.5. Báo cáo B04/BCTC',
        isParent: false,
        part: 5,
        level: 2,
        toggleAuditValue: 115,
        errorAuditValue: 115,
        parentAuditValue: 11,
        report_id: ['BCTC-04-Audit', 'BCTC-04'],
      },
      {
        typeAudit: 11,
        text: '11.6. Báo cáo B05/BCTC',
        isParent: false,
        part: 6,
        level: 2,
        toggleAuditValue: 116,
        errorAuditValue: 116,
        parentAuditValue: 11,
        report_id: ['BCTC-05-Audit', 'BCTC-05'],
      },
      {
        typeAudit: 11,
        text: '11.7. Báo cáo B01/BSTT',
        isParent: false,
        part: 7,
        level: 2,
        toggleAuditValue: 117,
        errorAuditValue: 117,
        parentAuditValue: 11,
        report_id: ['BCTC-01bstt-Audit', 'BCTC-01bstt'],
      },
      {
        typeAudit: 11,
        text: '11.8. Báo cáo C03/CCTT',
        isParent: true,
        part: 8,
        level: 2,
        toggleAuditValue: 118,
        errorAuditValue: 118,
        parentAuditValue: 11,
        report_id: '',
        childrens: [
          {
            typeAudit: 11,
            text: '11.8.1. Đối chiếu với báo cáo C03/CCTT',
            isParent: false,
            level: 3,
            toggleAuditValue: 1181,
            errorAuditValue: 1181,
            parentAuditValue: 118,
            report_id: ['C03/CCTT-Audit', 'C03/CCTT'],
            report_id_compare: ['C03/CCTT-Audit', 'C03/CCTT'],
          },
          {
            typeAudit: 11,
            text: '11.8.2. Đối chiếu với báo cáo B01/BCTC',
            isParent: false,
            level: 3,
            toggleAuditValue: 1182,
            errorAuditValue: 1182,
            parentAuditValue: 118,
            report_id: ['C03/CCTT-Audit', 'C03/CCTT'],
            report_id_compare: ['BCTC-01-Audit', 'BCTC-01'],
          },
          {
            typeAudit: 11,
            text: '11.8.3. Đối chiếu với báo cáo B04/BCTC',
            isParent: false,
            level: 3,
            toggleAuditValue: 1183,
            errorAuditValue: 1183,
            parentAuditValue: 118,
            report_id: ['C03/CCTT-Audit', 'C03/CCTT'],
            report_id_compare: ['BCTC-04-Audit', 'BCTC-04'],
          },
          {
            typeAudit: 11,
            text: '11.8.4. Đối chiếu với báo cáo B05/BCTC',
            isParent: false,
            level: 3,
            toggleAuditValue: 1184,
            errorAuditValue: 1184,
            parentAuditValue: 118,
            report_id: ['C03/CCTT-Audit', 'C03/CCTT'],
            report_id_compare: ['BCTC-05-Audit', 'BCTC-05'],
          },
        ],
      },
    ],
  },
  {
    typeAudit: 12,
    key: '',
    text: '12. Báo cáo quyết toán',
    isParent: true,
    part: 1,
    level: 1,
    toggleAuditValue: 12,
    errorAuditValue: 12,
    parentAuditValue: -1,
    isVisible: true,
    report_id: '',
    childrens: [
      {
        typeAudit: 12,
        text: '12.1. Báo cáo B01/BCQT',
        isParent: false,
        part: 1,
        level: 2,
        toggleAuditValue: 121,
        errorAuditValue: 121,
        parentAuditValue: 12,
        report_id: ['01_BCQT_Audit', '01_BCQT'],
      },
      {
        typeAudit: 12,
        text: '12.2. Phụ biểu F01-02/BCQT',
        isParent: false,
        part: 2,
        level: 2,
        toggleAuditValue: 122,
        errorAuditValue: 122,
        parentAuditValue: 12,
        report_id: ['F01_02_BCQT_P1_Audit', 'F01_02_BCQT_P1'],
      },
    ],
  },
];

let MenuAuditTypeCombo = {
  All: 'Tất cả',
  UnrecordDocument: '1. Chứng từ chưa ghi sổ',
  CashDeposit: '2. Tiền mặt, tiền gửi',
  AuditInventory: '3. Kho',
  FixedAsset: '4. Tài sản cố định',
  AdvanceVoucher: '5. Chứng từ chưa thanh toán tạm ứng',
  VoucherParalell: '6. Hạch toán tài chính và hạch toán ngoài bảng',
  AuditWithDrawBudget: '7. Sổ rút và chi theo mục lục ngân sách',
  AuditSalary: '8. Tài khoản lương và các khoản trích theo lương',
  AuditAnomalyBusiness: '9. Nghiệp vụ bất thường',
  AuditMovementBalance: '10. Bảng cân đối phát sinh',
  AuditFinancial: '11. Báo cáo tài chính',
  AuditSettlement: '12. Báo cáo quyết toán',
};

let dataFixedAssetData = [
  {
    dataName: 'diffBalanceAuditFixedDatas',
    errorAuditValue: 41,
  },
  {
    dataName: 'generalLedgerNotInFixedAssetDatas',
    errorAuditValue: 421,
  },
  {
    dataName: 'fixedAssetNotLedgerDatas',
    errorAuditValue: 422,
  },
  {
    dataName: 'incrementFixedAssetVoucherDatas',
    errorAuditValue: 423,
  },
  {
    dataName: 'checkDiffFAAdjustments',
    errorAuditValue: 424,
  },
  {
    dataName: 'checkFADepreciationMessage',
    errorAuditValue: 425,
  },
  {
    dataName: 'checkFADepreciation',
    errorAuditValue: 426,
  },
  {
    dataName: 'diffBalanceAuditFixedQLTS',
    errorAuditValue: 41,
  },
  {
    dataName: 'generalLedgerNotInFixedAssetQLTS',
    errorAuditValue: 421,
  },
  {
    dataName: 'fixedAssetNotLedgerQLTS',
    errorAuditValue: 422,
  },
  {
    dataName: 'incrementFixedAssetVoucherQLTS',
    errorAuditValue: 423,
  },
  {
    dataName: 'fixedAssetAdjustmentQLTS',
    errorAuditValue: 424,
  },
  {
    dataName: 'fixedAssetAdjustmentOtherQLTS',
    errorAuditValue: 425,
  },
  {
    dataName: 'fixedAssetDepreciationQLTS',
    errorAuditValue: 426,
  },
  {
    dataName: 'fixedAssetDepreciationMimoQLTS',
    errorAuditValue: 427,
  },
  {
    dataName: 'fixedAssetAtrophyQLTS',
    errorAuditValue: 428,
  },
  {
    dataName: 'fixedAssetAtrophyOtherQLTS',
    errorAuditValue: 429,
  },
  {
    dataName: 'fixedAssetWriteDownQLTS',
    errorAuditValue: 4210,
  },
  {
    dataName: 'fixedAssetAtrophyDownQLTS',
    errorAuditValue: 4211,
  },
];
let AuditChooseMenu = [
  {
    text: '1. Chứng từ chưa ghi sổ',
    isSelected: false,
    typeAudit: 1,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện các chứng từ chưa ghi sổ',
  },
  {
    text: '2. Tiền mặt, tiền gửi',
    isSelected: false,
    typeAudit: 2,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện số dư tài khoản tiền mặt, tiền gửi cuối kỳ âm',
  },
  {
    text: '3. Kho',
    isSelected: false,
    typeAudit: 3,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện vật tư hàng hoá số dư không hợp lý',
  },
  {
    text: '4. Tài sản cố định',
    isSelected: false,
    typeAudit: 4,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện số dư nguyên giá, hao mòn/khấu trừ hao luỹ kế của tài khoản không hợp lý',
  },
  {
    text: '5. Chứng từ chưa thanh toán tạm ứng',
    isSelected: false,
    typeAudit: 5,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện các khoản tạm ứng chưa được thanh toán với kho bạc',
  },
  {
    text: '6. Hạch toán tài chính ngoại bảng',
    isSelected: false,
    typeAudit: 6,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện chênh lệch giữa hạch toán tài chính và hạch toán ngoại bảng.',
  },
  {
    text: '7. Sổ rút và chi theo mục lục ngân sách',
    isSelected: false,
    typeAudit: 7,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện ra các mục lục ngân sách có số kinh phí rút và chi chưa hợp lý.',
  },
  {
    text: '8. Tài khoản lương & các khoản trích theo lương',
    isSelected: false,
    typeAudit: 8,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện các số dư lương và các khoản trích theo lương không hợp lý.',
  },
  {
    text: '9. Nghiệp vụ bất thường',
    isSelected: false,
    typeAudit: 9,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện ra các nghiệp vụ hạch toán bất thường chưa hợp lý.',
  },
  {
    text: '10. Bảng cân đối phát sinh',
    isSelected: false,
    typeAudit: 10,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện các tài khoản có số dư không phù hợp.',
  },
  {
    text: '11. Báo cáo tài chính',
    isSelected: false,
    typeAudit: 11,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện các chỉ tiêu báo cáo có số liệu không phù hợp.',
  },
  {
    text: '12. Báo cáo quyết toán',
    isSelected: false,
    typeAudit: 12,
    checkDate: 'Chưa kiểm tra',
    tooltip: 'Phát hiện các chỉ tiêu báo cáo có số liệu không phù hợp.',
  },
];

export default {
  MenuAudits,
  MenuAudit4NoQLTS,
  MenuAudit4QLTS,
  MenuAudit42NoQLTS,
  MenuAudit42QLTS,
  MenuAuditTypeCombo,
  dataFixedAssetData,
  AuditChooseMenu,
};
